import { PipelineStepConfiguration } from 'src/dto/PipelineStep';

export async function getConfigurationFromFile<TConfiguration extends PipelineStepConfiguration>(
  file: File,
): Promise<TConfiguration> {
  const configText = await file.text();

  return JSON.parse(configText) as TConfiguration;
}
